import { keyAccess, keyJwt } from "../../utils/helpers/helpers";
import TokenService from "./TokenService";

const getAccess = () => {
  let c = localStorage.getItem(keyAccess);
  if (c) {
    return JSON.parse(c);
  }
  return null;
};

const getRoles = () => {
  if (getAccess() !== null) {
    let roles: any[] = getAccess().role;
    return roles;
  }
  return [];
};

const getInfoToken = (key: string) => {
  let s = TokenService.getToken();
  if (s) {
    let t: any = JSON.parse(Buffer.from(s!.split(".")[1], "base64").toString());
    return t[key];
  }
  return null;
};

const removeToken = () => {
  localStorage.removeItem(keyJwt);
};

const AuthenticationService = {
  getInfoToken,
  getAccess,
  getRoles,
  removeToken,
};

export default AuthenticationService;
